import React from "react";
import "./style.scss";
import { PASSWORD_RULES_MESSAGE, passwordChecks } from "../../utils/helpers/string";

// Live checklist of the password rules, shown under a new-password field.
// With showWarning, a missing rule also shows the full rules message.
function PasswordRequirements({ password = "", showWarning = false }) {
  const checks = passwordChecks(password);
  const allMet = checks.every((check) => check.ok);

  return (
    <div className="password_requirements">
      <ul>
        {checks.map((check) => (
          <li key={check.label} className={check.ok ? "met" : ""}>
            <span aria-hidden="true">{check.ok ? "✓" : "•"}</span> {check.label}
          </li>
        ))}
      </ul>
      {showWarning && !allMet && <p className="password_requirements__warning">{PASSWORD_RULES_MESSAGE}</p>}
    </div>
  );
}

export default PasswordRequirements;
